const TAB_NAME = {
  HOME: 'home',
  DISCUSS: 'discuss',
  SHARE: 'share',
  MAKE: 'make',
};

export default TAB_NAME;
